import React from 'react'
import { Container, SizableText, Stack, TextLink, YStack } from '@my/ui'
import { KeyboardAwareScrollView, Logo, MainLayout, Meta } from 'app/components'
import { SignUpForm, SignUpFormValues } from './components'

export interface SignUpScreenProps {
  loading: boolean
  error: any
  onSubmit: (values: SignUpFormValues) => void
}

export const SignUpScreen = (props: SignUpScreenProps) => {
  return (
    <MainLayout>
      <Meta title="Sign up" />
      <KeyboardAwareScrollView style={{ flex: 1 }}>
        <Container gap="$3" flexGrow={1} size="xs" ai="center" jc="flex-start" spaceTop spaceBottom gutter>
          <Logo my="$3.5" width={90} />
          <YStack gap="$2" jc="flex-start" ai="center" w="100%">
            <SizableText textAlign="center" size="$7" fow="700">
              Get the best student discounts, freebies & giveaways!
            </SizableText>
            <SizableText textAlign="center" color="$overlay10" size="$4">
              Build a profile, join uni groups and get helpful tips & advice for all things uni
              life.
            </SizableText>
          </YStack>
          <YStack flexGrow={1} width="100%" alignItems="center">
            <SignUpForm loading={props.loading} error={props.error} onSubmit={props.onSubmit} />

            <SizableText mt="$4" fow="600">
              Already have an account?{' '}
              <TextLink fow="600" href="/log-in">
                Log in
              </TextLink>
            </SizableText>
          </YStack>
        </Container>
      </KeyboardAwareScrollView>
    </MainLayout>
  )
}
